export const withDataTest = <T extends object>(Component: React.ComponentType<T>, testId: string) => {
  return function ComponentWithDataTest(props: T) {
    return <Component {...(props as any)} data-test={testId} />;
  };
};
